import React from 'react'
import classnames from 'classnames'
import ProfileImage from 'components/ProfileImage'

const ProfileImageWithAspectRatio = ({ className, children, ...rest }) => (
  <div className="h-0 relative aspect-ratio-profile-picture">
    <ProfileImage
      className={classnames('absolute left-0 top-0 w-full h-full object-cover', className)}
      {...rest}
    />
    {children}
  </div>
)

export default ProfileImageWithAspectRatio
